import { resolveTsaSectionDurationMinutes } from './tsaPearsonCopy';

export function buildTsaOverviewRows({
  paper1Count,
  paper2Count,
  hasPaper2 = true,
  timed = false,
  paper1Minutes,
  paper2Minutes,
} = {}) {
  const q1 = Number(paper1Count) > 0 ? Number(paper1Count) : 50;
  const q2 = Number(paper2Count) > 0 ? Number(paper2Count) : 1;
  const m1 = resolveTsaSectionDurationMinutes(paper1Minutes, { section: 1 });
  const m2 = resolveTsaSectionDurationMinutes(paper2Minutes, { section: 2 });
  const rows = [
    {
      section: 'Section 1',
      questions: q1,
      time: timed ? `${m1} minutes` : 'Untimed',
    },
  ];
  if (hasPaper2) {
    rows.push({
      section: 'Section 2',
      questions: q2,
      time: timed ? `${m2} minutes` : 'Untimed',
    });
  }
  return rows;
}
